<!--banner starts-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
               style="background-image: url(../../assets/wereablebanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 50px;">
                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Wearable App Development Service</h1></div>
                    <div>
                        <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">
                            WebSoulLabs is a creative wearable app design and development firm who are specialists in creating native apps.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>       
<!--banner ends-->

<div class="uk-section uk-padding">
    <div class="uk-container">
        <h2 class="uk-text-center" ><span>Trendy Big Data Solutions</span></h2>
    
        <p class="uk-text-medium uk-text-justify">  
            Wearable technology is a prospective technology that the modern age business will make use of. Wearable application development has influenced several businesses, mainly the fitness and healthcare sectors. By incorporating IoT technology, wearable technology will make surges in the corporate sector.
        </p>
        <p class="uk-text-medium uk-text-justify"> 
            Our experienced wearable app developers are skilled to develop hi-end apps such as a health app for Apple Watch or a google glass app. Our wearable apps offer various services to small and big businesses as well as manufacturing companies to improve their job skills. It gives real-time relations between the management and employees at work
        </p>
    </div>
    </div>
    <br>
    <!--Paragraph part code ends-->
    <!--Services part code-->
<div class="uk-container uk-container-expand">
    <div class="ws-services  uk-child-width-1-3@s uk-flex-center uk-light uk-grid-match" uk-grid>
        <h1 class="uk-padding-small uk-align-center">Wearable App Development Services</h1>
        
        <div>
            
            <div class="uk-placeholder uk-text-center uk-panel">
                
                 <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                
                   

                    
                    <div class="pa">
                        <span class="text-white">
                    <img class="uk-border-circle " src="assets/smart-watch.png"
                        width="75" height="75" alt="" ></span>
                    </div>
             
                 </div>
                <h4 style="margin-top: 0px;"><strong>Smart Watch Apps</strong></h4>
                <p class="uk-text-justify">Android handily beats the iPhone because it provides a lot more flexibility, functionality and freedom of choice. Android, developed and owned by Google, runs on many different devices from different manufacturers.</p>

            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">

                   
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/iot.png"
                        width="70" height="70" alt=""></span>
                </div>
                </div>
                <h4 style="margin-top: 0px;"><strong>IoT based Wearable Apps</strong></h4>
                <p class="uk-text-justify">Wearable devices are the most visible consumer Internet of Things (IoT) technology. IoT refers to electronic devices that can be connected through internet networks.
                </p>

            </div>
        </div>

        <div>
            <div class="uk-placeholder uk-text-center uk-panel ">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/android-wear.png"
                        width="68" height="68" alt=""></span>
                </div>
               </div>
                <h4 style="margin-top: 0px;"><strong>Android Wear</strong></h4>
                <p class="uk-text-justify">The Android Wear app is required to pair your android wear smart watch to your android device. It displays possible voice actions and lets you change settings like muting specific apps for notifications.
                </p>

            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel ">

                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/phone-call.svg"
                        width="68" height="68" alt="border-circle"></span>
                </div>
                </div>
                <h4 style="margin-top: 0px;"><strong>Samsung Gear</strong></h4>
                <p class="uk-text-justify">The Samsung Gear application connects your Samsung Gear to your mobile device. It also manages and monitors the Samsung Gear features and applications you've installed through the Gear Apps </p>

            </div>
        </div>


        <div>

            <div class="uk-placeholder uk-text-center uk-panel ">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                  
                        <div class="pa">
                            <span class="text-white">
                    <img class="uk-border-circle" src="assets/smartwatch.svg"
                        width="70" height="70" alt=""></span>
                </div>
                </div>
                <h4 style="margin-top: 0px;"><strong>GPS Watch</strong></h4>
                <p class="uk-text-justify"> A large number of the wearable GPS devices can perform a host of functions such as tracking your sleep, monitoring your heart rate, counting the number of steps.
                </p>

            </div>
        </div>
        <div>

            <div class="uk-placeholder uk-text-center uk-panel  uk-animation-fast uk-animation-fade">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                 
                    <div class="pa">
                            <span class="text-white">
                      <img class="uk-border-circle "  src="assets/heartbeat.svg"
                        width="68" height="68" alt=""></span>
                   </div>
                 </div>
                
            
                <h4 style="margin-top: 0px;"><strong>Fitbit</strong></h4>
                <p class="uk-text-justify">This app can access your Internet connection and act as a server. Use the appointments in your calendar. Close themselves and their own windows, and delay the closing of their app.
                </p>

            </div>
        </div>
    </div>
</div>
<!--Services part code ends-->
<div class="uk-section uk-padding" style=" padding-bottom: 0px;">
    <div class="uk-container">
      
          <h2 class="uk-text-center">Source Of BigData</h2>
          <br>
          <div class="uk-column-1-2@s">
  
              
            <ul class=" uk-text-medium uk-text-justify">
                <li>Social data comes from the likes, tweets & re-tweets, comments, video uploads, and general media that are uploaded and shared via the world’s favorite social media platforms.</li>
                <li>Cloud storage accommodates structured and unstructured data and provides business with real-time information and on-demand insights.</li>
                <li>Machine-generated content or data created from IoT constitute a valuable source of big data. </li>
                <li>Electronic files refers to unstructured documents, statically or dynamically produced which are stored or published as electronic files, like Internet pages, videos, audios, PDF files, etc.</li>
                <li>Machine data is defined as information which is generated by industrial equipment, sensors that are installed in machinery, and even web logs which track user behavior. </li>
                <li>Broadcastings mainly referred to video and audio produced on real time, getting statistical data from the contents of this kind of electronic data. </li>

            
                
            </ul>
              <img data-src="assets/we1.jpg" width="1000" height="1000" alt="" uk-img>
  <br><br>
          </div>
    </div>
</div>
<h1 class="uk-text-center"><span>Related Services</span></h1>
<br>
<div class="uk-container">
    <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center " uk-grid>
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/ib1.png" width="120" height="120" alt="">
                <h4 class="uk-text-center"  style="font-weight: 600; ">iBeacon App</h4>


            </div>
        </div>

        <div>

            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/tv1.png" width="120" height="120" alt="">
                <h4 class="uk-text-center"  style=" font-weight: 600; ">Interactive TV App</h4>


            </div>
        </div>


        

        

        

       


       

    </div>

</div>

<!--Related Services part code ends-->



<!--Technology stack part code-->
<br>
<h1 class="uk-text-center"><span>Technology Stack</span></h1>
<br>
<div class="uk-container">
    <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/swi.jpg" width="90" height="90"
                    alt="border-circle">
                    <h4  style="font-weight: 600;"> Swift </h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/and.png" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;"> Android </h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/java.jpg" width="90" height="90"
                    alt="border-circle">
                    <h4  style="font-weight: 600;"> Java </h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/apple.png" width="90" height="90"
                    alt="border-circle">
                    <h4  style="font-weight: 600;"> IOS </h4>
            </div>
        </div>
    </div>
    <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/kotlin.jpg" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;"> Kotlin </h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/node.jpg" width="80" height="80"
                    alt="border-circle">
                    <h4  style="font-weight: 600;"> Node JS </h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/angular.png" width="90" height="90"
                    alt="border-circle">
                    <h4  style="font-weight: 600;"> Angular JS </h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/React.webp" width="90" height="90"
                    alt="border-circle">
                    <h4  style="font-weight: 600;"> React JS </h4>
            </div>
        </div>
    </div>
    
</div>
<br>
<!--Technology stack part code ends-->


